






// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBasePartenaire from '@/components/partenaire/edit/EditBasePartenaire.vue'
import { getDefaultAloPartenaire, AloPartenaire } from '@/models/alo/AloPartenaire'
import {PartRestrictFlag} from '@/enum/PartRestrictFlag'

@Component({
  name: 'EditParamCw',    
  components:{EditBasePartenaire}
})
export default class EditParamCw extends Vue {
    
  private partenaire:AloPartenaire = getDefaultAloPartenaire()
  private showDrawer = false
  private saving = false  

  edit(item:AloPartenaire) {    
    this.partenaire = (this.$refs.baseEdit as EditBasePartenaire).edit(item)
  }  

  private get restrictionsAcces(){
    return Object.keys(PartRestrictFlag)
  }

  get restricted(){
    return this.partenaire.ptnRestrictedFlag && this.partenaire.ptnRestrictedFlag.length >0 &&  this.partenaire.ptnRestrictedFlag != 'none'?this.partenaire.ptnRestrictedFlag.split(', '):[]
  }

  set restricted(value:Array<string>)
  {
    this.partenaire.ptnRestrictedFlag = value.length>0?value.join(', '):'none'
  }

}
